import React from 'react'
import { ReactNode, useState, createContext, useContext } from 'react'

export interface IPaymentSource {
  label: string
  value: string
}

export interface PaymentSourceContextType {
  paymentSource: IPaymentSource | null
  setPaymentSource: (paymentSource: IPaymentSource | null) => void
}

export const PaymentSourceContext = createContext<PaymentSourceContextType | null>(null)

export const PaymentSourceProvider = ({ children }: { children: ReactNode }) => {
  const [paymentSource, setPaymentSource] = useState<IPaymentSource | null>(null)
  return (
    <PaymentSourceContext.Provider value={{ paymentSource, setPaymentSource }}>
      {children}
    </PaymentSourceContext.Provider>
  )
}

export const usePaymentSource = (): PaymentSourceContextType => {
  const context = useContext(PaymentSourceContext)
  if (!context) {
    throw new Error('usePaymentSource must be used within a PaymentSourceProvider')
  }
  return context
}



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/payments/PaymentSourceContext.tsx